import React, { createContext, useCallback, useContext, useMemo, useState } from 'react';

interface HeaderVisibilityContextType {
  isHeaderVisible: boolean;
  setHeaderVisible: (visible: boolean) => void;
}

const HeaderVisibilityContext = createContext<HeaderVisibilityContextType>({
  isHeaderVisible: true,
  setHeaderVisible: () => {},
});

export const HeaderVisibilityProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [isHeaderVisible, setIsHeaderVisible] = useState(true);

  const setHeaderVisible = useCallback((visible: boolean) => {
    setIsHeaderVisible(visible);
  }, []);

  return (
    <HeaderVisibilityContext.Provider
      value={useMemo(() => ({ isHeaderVisible, setHeaderVisible }), [isHeaderVisible, setHeaderVisible])}
    >
      {children}
    </HeaderVisibilityContext.Provider>
  );
};

export const useHeaderVisibility = () => useContext(HeaderVisibilityContext);
